<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <h5>Energie electrica</h5>
        </div>
        <div class="card-body tab2-card">
          <ngb-tabset class="tab-coupon">
            <ngb-tab title="Locuri de consum">
              <ng-template ngbTabContent>
                <div class="tab-pane fade active show" id="place" role="tabpanel" aria-labelledby="account-tab">
                  <div class="form-group row">
                    <div class="col-xl-3 col-md-3">
                      <button type="button" class="btn btn-primary" (click)="createConsumptionPlace()">
                        Adauga loc de consum nou
                      </button>
                    </div>
                  </div>
                  <form [formGroup]="placeForm" class="needs-validation" novalidate>
                    <div class="form-group row">
                      <div class="col-xl-3 col-md-3">
                        <label>POD</label>
                        <input class="form-control" type="text" formControlName="code">
                      </div>
                      <div class="col-xl-3 col-md-3">
                        <label>Denumire client</label>
                        <input class="form-control" type="text" formControlName="client">
                      </div>
                      <div class="col-xl-auto col-md-auto" style="margin-top: auto">
                        <button type="button" class="btn btn-primary" (click)="searchPlaces(0)">
                          Cauta
                        </button>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-xl-3 col-sm-3 mb-0">
                        <label>Judet</label>
                        <select class="form-control digits" formControlName="county" (change)="onChangeCounty()">
                          <option *ngFor="let county of counties" [value]="county.id">
                            {{ county.name }} </option>
                        </select>
                      </div>
                      <div class="col-xl-3 col-sm-3 mb-0">
                        <label>Localitate</label>
                        <select class="form-control digits" formControlName="city">
                          <option *ngFor="let city of cities" [value]="city.id">
                            {{ city.name }} </option>
                        </select>
                      </div>
                    </div>
                  </form>
                  <br>
                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="consumptionPlaceSettings"
                        [source]="electricityConsumptionPlaces?.content"
                        (custom)="onCustomActionConsumptionPlace($event)"></ng2-smart-table>
                    </div>
                  </div>
                  <div *ngIf="electricityConsumptionPlaces?.totalElements > 0">
                    <h4 class="pagination justify-content-center">
                      Total Locuri Consum {{electricityConsumptionPlaces.totalElements}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousPage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationElectricityConsumptionPlaces" [ngClass]="page.className"
                        (click)="changePage(page)">
                        <a class="page-link">{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextPage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>
            <ngb-tab>
              <ng-template ngbTabTitle>Furnizori
                <ng-template ngbTabContent>
                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="supplierSettings" [source]="electricitySuppliers"
                        (custom)="onCustomActionSuppliers($event)"></ng2-smart-table>
                    </div>
                  </div>
                </ng-template>
              </ng-template>
            </ngb-tab>
            <ngb-tab>
              <ng-template ngbTabTitle>Contracte retea
                <ng-template ngbTabContent>
                  <div class="tab-pane fade active show" id="nwrokContract" role="tabpanel"
                    aria-labelledby="account-tab">
                    <div class="form-group row">
                      <div class="col-xl-3 col-md-3">
                        <button type="button" class="btn btn-primary" (click)="createNetworkContract()">
                          Adauga contract de retea
                        </button>
                      </div>
                    </div>
                    <form [formGroup]="networkContractForm" class="needs-validation" novalidate>
                      <div class="form-group row">
                        <div class="col-xl-3 col-md-3">
                          <label>CUI / CNP / Numar identificare</label>
                          <input class="form-control" type="text" formControlName="code">
                        </div>
                        <div class="col-xl-3 col-md-3">
                          <label>Client</label>
                          <input class="form-control" type="text" formControlName="client">
                        </div>
                        <div class="col-xl-auto col-md-auto" style="margin-top: auto">
                          <button type="button" class="btn btn-primary" (click)="searchNetworkContracts(0)">
                            Cauta
                          </button>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-xl-3 col-sm-3 mb-0">
                          <label>Numar</label>
                          <input class="form-control" type="text" formControlName="number">
                        </div>
                        <div class="col-xl-3 col-sm-3 mb-0">
                          <label>Tip contract</label>
                          <select class="form-control digits" formControlName="contractType">
                            <option value="RETEA">RETEA</option>
                            <option value="TRANSPORT">TRANSPORT</option>
                          </select>
                        </div>
                      </div>
                    </form>
                    <div class="category-table custom-datatable">
                      <div class="table-responsive">
                        <ng2-smart-table [settings]="contractNetworkSettings" [source]="networkContracts?.content"
                          (custom)="onCustomActionNetworkContract($event)"></ng2-smart-table>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="networkContracts?.totalElements">
                    <h4 class="pagination justify-content-center">
                      Total contracte de retea: {{networkContracts?.totalElements}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousNetworkContractPage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationNetworkContracts" [ngClass]="page.className"
                        (click)="changeNetworkContractPage(page)">
                        <a class="page-link">{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextNetworkContractPage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </ng-template>
              </ng-template>
            </ngb-tab>
          </ngb-tabset>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->